import { render, staticRenderFns } from "./ActiveAlerts.vue?vue&type=template&id=dcf9ca3c&scoped=true"
import script from "./ActiveAlerts.vue?vue&type=script&lang=js"
export * from "./ActiveAlerts.vue?vue&type=script&lang=js"
import style0 from "./ActiveAlerts.vue?vue&type=style&index=0&id=dcf9ca3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf9ca3c",
  null
  
)

export default component.exports